/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { User } from "@src/app/model/user";
import { DebtorsListComponent } from "@src/app/modules/txn/debtors-list/debtors-list.component";
import { DateHelper } from "@src/app/shared/dateHelper";
import { NavRoute } from "@src/app/shared/NavRoute";

export const DebtorsListPageNavRoute = new NavRoute('debtorsList', ()=>DebtorsListComponent, 'price_check').setViews((u: User) => {
    return [
        {
            id: 'scoredYear',
            name: 'Scored Debtors List',
            helpText: 'All debtors scored by number of charges outstanding',
            filterFields: {
                frequencyId: 'any',
                ownerName: null,
            },
        },
        {
            id: 'overdue31',
            name: '31 Days Overdue',
            helpText: 'Units with no payment in the last 31 days',
            filterFields: {
                lastPay: DateHelper.today(-31),
                frequencyId: '12',
                ownerName: null,
            },
        },
        {
            id: 'overdue60',
            name: '60 Days Overdue',
            helpText: 'Units with no payment in the last 60 days',
            filterFields: {
                lastPay: DateHelper.today(-60),
                frequencyId: '12',
                ownerName: null,
            },
        },
        {
            id: 'inArrears',
            name: '>1 charge owing',
            helpText: 'Units with two or more unpaid service charges',
            filterFields: {
                invoices: '>=2',
                frequencyId: 'any',
                ownerName: null,
            },
        },
        {
            id: 'inArrears2',
            name: '>2 Charges owing',
            helpText: 'Units with three or more unpaid service charges',
            filterFields: {
                invoices: '>=3',
                frequencyId: 'any',
                ownerName: null,
            },
        },
        {
            id: 'paymentPlan',
            name: 'This years payment plan',
            helpText: 'Units on an annual payment plan with one charge owing',
            filterFields: {
                frequencyId: '12',
                invoices: '1',
                ownerName: null,
            },
        },
        {
            id: 'asAtDate',
            name: 'Debtors as at Date',
            helpText: 'Debtor balances as at end of previous financial period; adjust the date to show balances at a date of your choosing',
            filterFields: {
                asAtDate: u.currentTeam?.currentPeriod?.from ?
                    DateHelper.adjustDate(u.currentTeam?.currentPeriod?.from, -1) : '1999-12-31',
                ownerName: null,
            },
        }
    ]
});
